// @flow

import React from 'react';
import Box from 'components/Box';
import { H2, Body } from 'components/Text';
import Video from 'components/Video';
import type { VideoBlockData } from 'api/cms';

const VideoBlock = ({
  data: { headline, subtitle, videoUrl },
  fullWidthLayout
}: {
  data: VideoBlockData,
  fullWidthLayout?: boolean
}) => (
  <Box>
    {(headline || subtitle) && (
      <Box mb={48}>
        {headline && (
          <H2 textAlign={fullWidthLayout ? 'center' : 'left'}>{headline}</H2>
        )}
        {subtitle && (
          <Body
            textAlign={fullWidthLayout ? 'center' : 'left'}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        )}
      </Box>
    )}
    <Video prefix="cms-embed" url={videoUrl} />
  </Box>
);

export default VideoBlock;
